"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComparisonBar = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _PrimaryLayout = require("b2b-components/theme/components/PrimaryLayout");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _ComparisonBarActons = require("./ComparisonBarActons");
var _ComparisonBarItem = require("./ComparisonBarItem");
var _ = require("./");
require("./ComparisonBar.scss");
const ComparisonBar = _ref => {
  let {
    items,
    label,
    onItemClick,
    onItemRemove,
    onCompareClick,
    compareButtonLabel,
    maxNumberOfItems = _.MAX_NUMBER_OF_ITEMS,
    actions,
    isVisible,
    className,
    itemClassName,
    itemTooltipClassName,
    deviceType,
    dataAttributes
  } = _ref;
  const preparedItems = items.slice(0, maxNumberOfItems);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: (0, _classnames.default)('cds-ComparisonBar', {
      'cds-ComparisonBar--Visible': isVisible
    }, className)
  }), /*#__PURE__*/_react.default.createElement(_PrimaryLayout.PrimaryLayout, {
    className: "cds-ComparisonBar-Content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ComparisonBar-Box cds-ComparisonBar-Box--Label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-ComparisonBar-Label"
  }, label, " (", preparedItems.length, "/", maxNumberOfItems, "):")), /*#__PURE__*/_react.default.createElement("ul", {
    className: "cds-ComparisonBar-List"
  }, preparedItems.map((item, index) => /*#__PURE__*/_react.default.createElement(_ComparisonBarItem.ComparisonBarItem, {
    item: item,
    onClick: onItemClick,
    onRemove: onItemRemove,
    className: itemClassName,
    tooltipClassName: itemTooltipClassName,
    deviceType: deviceType,
    key: (0, _key.createKey)(item.id, index)
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ComparisonBar-Box cds-ComparisonBar-Box--CompareButton"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: onCompareClick,
    size: _Button.BUTTON_SIZE.small,
    isDisabled: !preparedItems.length
  }, compareButtonLabel, " (", preparedItems.length, ")")), actions.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ComparisonBar-Box cds-ComparisonBar-Box--ActionsButton"
  }, /*#__PURE__*/_react.default.createElement(_ComparisonBarActons.ComparisonBarActions, {
    actions: actions,
    isVisible: isVisible
  }))));
};
exports.ComparisonBar = ComparisonBar;
//# sourceMappingURL=ComparisonBar.js.map